import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Col,
  Row,
} from '@folio/stripes/components';

import css from './task-template-title.css';

const TaskTemplateTitle = () => {
  return (
    <Row>
      <Col
        data-test-job-template-task-templates-title-order
        className={css.taskTemplatesHeaderCell}
        sm={11}
      >
        <FormattedMessage id="ui-task-list.jobTemplate.taskTemplates.field.order" />
      </Col>

      <Col
        data-test-job-template-task-templates-title-actions
        className={css.taskTemplatesHeaderCell}
        sm={1}
      >
        <FormattedMessage id="ui-task-list.jobTemplate.taskTemplates.field.actions" />
      </Col>
    </Row>
  );
};

export default TaskTemplateTitle;
